const PATHS = {
  '/dashboard': 'dashboard',
  '/dashboard/episode/:podcastEpisodeId': 'episode_details',
  '/dashboard/episode/:podcastEpisodeId/edit': 'episode_edit',
  '/dashboard/episode/new': 'new_episode',
  '/dashboard/money': 'wallet',
  '/dashboard/podcast/edit': 'settings',
  '/login': 'log_in',
  '/signup': 'sign_up',
};

export default function getScreenFromRoute(pathname) {
  return PATHS[pathname];
}
